"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// import { QuickActionSubMenu } from '../Navigation/index';
var RiskObjectBarDataGroup = function RiskObjectBarDataGroup(_ref) {
  var label = _ref.label,
      data = _ref.data,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(RiskObjectBarData, {
    className: size
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement("span", {
    className: "data"
  }, data), children);
};

RiskObjectBarDataGroup.propTypes = {
  label: _propTypes.string,
  data: _propTypes.string,
  children: _propTypes.node,
  size: _propTypes.string
};

var RiskObjectBar = function RiskObjectBar(_ref2) {
  var icon = _ref2.icon,
      children = _ref2.children,
      isDragItem = _ref2.isDragItem,
      onClick = _ref2.onClick,
      otherProps = _objectWithoutProperties(_ref2, ["icon", "children", "isDragItem", "onClick"]);

  var IconToRender;

  if (icon !== '') {
    IconToRender = /*#__PURE__*/_react.default.createElement(RiskObjectBarIcon, null, icon);
  }

  return /*#__PURE__*/_react.default.createElement(RiskObjectBarContainer, _extends({
    onClick: onClick,
    isDragItem: isDragItem
  }, otherProps), /*#__PURE__*/_react.default.createElement("section", null, IconToRender, children));
};

var RiskObjectBarData = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectBarData"
})(["display:flex;flex-direction:column;align-items:flex-start;flex:1 1 0;min-width:10rem;.label{font-weight:normal;font-size:1.4rem;line-height:120%;color:", ";}.data{color:#505050;font-weight:500;font-size:1.6rem;line-height:120%;}&.double{flex:2 0 auto;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.labels.defaultText;
});

var RiskObjectBarDataWrapper = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectBarDataWrapper"
})(["width:100%;display:flex;align-items:flex-start;flex-wrap:wrap;gap:2rem;"]);

var RiskObjectBarContainer = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectBarContainer"
})(["background-color:white;box-shadow:0 2px 5px rgba(0,0,0,0.05);width:100%;padding:", ";display:flex;justify-content:flex-start;align-items:center;font-family:", ";border:1px solid ", ";border-radius:5px;max-width:100rem;cursor:", ";section{flex:1 1 auto;display:flex;justify-content:flex-start;align-items:center;flex-wrap:nowrap;> div:not(:last-of-type){margin-right:50px;}}&:hover{background-color:", ";border:1px solid ", ";cursor:pointer;& ", " span{color:", ";}}"], function (_ref4) {
  var isDragItem = _ref4.isDragItem;
  return isDragItem === true ? '25px 25px 25px 45px' : '25px';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ui.outline;
}, function (_ref7) {
  var onClick = _ref7.onClick;
  return onClick !== undefined ? 'pointer' : 'auto';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brand.lightest;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.brand.primary;
}, RiskObjectBarData, function (_ref10) {
  var theme = _ref10.theme;
  return theme.brand.primary;
});

RiskObjectBar.propTypes = {
  /** The name of the icon to be shown. No icon will be shown if left empty. */
  icon: _propTypes.string,
  children: _propTypes.node,

  /** Add this prop if the item is used in a Draggable component. */
  isDragItem: _propTypes.bool,
  onClick: _propTypes.func,
  otherProps: _propTypes.object
};
RiskObjectBar.defaultProps = {
  otherProps: {},
  icon: _propTypes.node,
  isDragItem: false
};
RiskObjectBar.RiskObjectBarData = RiskObjectBarDataGroup;
RiskObjectBar.RiskObjectBarDataWrapper = RiskObjectBarDataWrapper;
RiskObjectBar.RiskObjectBarData.displayName = 'RiskObjectBar.RiskObjectBarData';
RiskObjectBar.RiskObjectBarDataWrapper.displayName = 'RiskObjectBar.RiskObjectBarDataWrapper';

var RiskObjectBarIcon = _styledComponents.default.div.withConfig({
  displayName: "RiskObjectBarIcon"
})([""]);

var _default = RiskObjectBar;
exports.default = _default;